import { BROWSER_STORAGE, BrowserStorage } from 'src/services/storages/storage';

export const localStorageService = new BrowserStorage(
  BROWSER_STORAGE.LocalStorage
);

Object.freeze(localStorageService);
